module.exports = __webpack_public_path__ + "img/webinars.d2dfb528.svg";